import cn from '../../../../utils/cn';

function CustomerDetailsStatus({ data }) {
    if (data?.status === 'active') return null;

    return (
        <div
            className={cn(
                `h-10 bg-warning text-white rounded-lg mb-5 p-2 flex justify-start items-center gap-4`,
                {
                    'bg-warning': data?.status === 'inactive'
                }
            )}
        >
            <span>{data?.note}</span>
        </div>
    );
}

export default CustomerDetailsStatus;
